var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "course-contents": true,
        "trial-paywall-container": _vm.onTrialPaywall,
        mobile: _vm.useMobileStyles,
        "two-page-treatment": _vm.twoPageGroup
      }
    },
    [
      _vm.twoPageGroup
        ? _c("div", { staticClass: "header-container" }, [
            _c(
              "h3",
              { attrs: { "data-testid": "trial_paywall_two_page_header" } },
              [
                _vm._v(
                  "\n      Unlock the full Brilliant experience, free for " +
                    _vm._s(_vm.trialLength) +
                    " days.\n    "
                )
              ]
            ),
            _vm._v(" "),
            _c("p", { staticClass: "subheader" }, [
              _vm._v(
                "\n      Get unlimited access to all math, science, and computer science courses on Brilliant.\n    "
              )
            ])
          ])
        : _c("h3", [_vm._v("What's inside")]),
      _vm._v(" "),
      _vm.onTrialPaywall && !_vm.isMobile(_vm.$mq)
        ? _c("div", { staticClass: "two-page-header features" }, [
            _c("div", { staticClass: "left" }, [
              _c("div", { staticClass: "item heart" }, [
                _c("span", { staticClass: "icon" }, [
                  _vm.onTrialPaywall
                    ? _c("span", {
                        staticClass: "b-sprite-paywall-pix-heart-small"
                      })
                    : _c("span", {
                        staticClass: "b-sprite-paywall-pix-simple-heart"
                      })
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v("Learn deeply")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          From algebra to quantum physics, enjoy fun, interactive lessons in thousands of\n          interesting topics.\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item explanations" }, [
                _c("span", { staticClass: "icon" }, [
                  _vm.onTrialPaywall
                    ? _c("span", {
                        staticClass: "b-sprite-paywall-pix-chat-small"
                      })
                    : _c("span", {
                        staticClass: "b-sprite-paywall-pix-message"
                      })
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v("In-depth explanations")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          Master concepts with step-by-step explanations of key ideas and problem solving\n          techniques.\n        "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "center" }, [
              _c("img", {
                staticClass: "ui pix",
                attrs: {
                  src: _vm.useMobileStyles
                    ? [
                        "/site_media/version-48936c8584/images/paywall/trial-paywall-two-page-mobile-example.png"
                      ]
                    : [
                        "/site_media/version-385428c7d1/images/paywall/trial-paywall-two-page-desktop.png"
                      ]
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "right" }, [
              _c("div", { staticClass: "item problem" }, [
                _c("span", { staticClass: "icon" }, [
                  _vm.onTrialPaywall
                    ? _c("span", {
                        staticClass: "b-sprite-paywall-pix-lightbulb-small"
                      })
                    : _c("span", {
                        staticClass: "b-sprite-paywall-pix-simple-lightbulb"
                      })
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v("Problem solving")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Improve critical thinking skills with mind-bending problems and puzzles."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item interactive" }, [
                _c("span", { staticClass: "icon" }, [
                  _vm.onTrialPaywall
                    ? _c("span", {
                        staticClass: "b-sprite-paywall-pix-interactives-small"
                      })
                    : _c("span", { staticClass: "b-sprite-paywall-pix-click" })
                ]),
                _vm._v(" "),
                _c("h4", [_vm._v("Interactive lessons")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Drag objects and manipulate variables to get to aha moments fast."
                  )
                ])
              ])
            ])
          ])
        : _c(
            "div",
            { staticClass: "features" },
            [
              _vm.twoPageGroup
                ? _c("ResponsiveImage", {
                    staticClass: "ui pix",
                    attrs: {
                      src: _vm.useMobileStyles
                        ? [
                            "/site_media/version-48936c8584/images/paywall/trial-paywall-two-page-mobile-example.png"
                          ]
                        : [
                            "/site_media/version-385428c7d1/images/paywall/trial-paywall-two-page-desktop.png"
                          ],
                      alt: "Demo"
                    }
                  })
                : _vm.onTrialPaywall
                ? _c("ResponsiveImage", {
                    staticClass: "ui pix",
                    attrs: {
                      src: _vm.useMobileStyles
                        ? [
                            "/site_media/version-2fcb9236df/images/paywall/trial-paywall-experiment-mobile-example.png"
                          ]
                        : [
                            "/site_media/version-da39a3ee5e/images/paywall/trial-paywall-experiment-desktop-example.png"
                          ],
                      alt: "Demo"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "items" }, [
                _c("div", { staticClass: "item heart" }, [
                  _c("span", { staticClass: "icon" }, [
                    _vm.onTrialPaywall
                      ? _c("span", {
                          staticClass: "b-sprite-paywall-pix-heart-small"
                        })
                      : _c("span", {
                          staticClass: "b-sprite-paywall-pix-simple-heart"
                        })
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Learn deeply")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          From algebra to quantum physics, enjoy fun, interactive lessons in thousands of\n          interesting topics.\n        "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item problem" }, [
                  _c("span", { staticClass: "icon" }, [
                    _vm.onTrialPaywall
                      ? _c("span", {
                          staticClass: "b-sprite-paywall-pix-lightbulb-small"
                        })
                      : _c("span", {
                          staticClass: "b-sprite-paywall-pix-simple-lightbulb"
                        })
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Problem solving")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Improve critical thinking skills with mind-bending problems and puzzles."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item interactive" }, [
                  _c("span", { staticClass: "icon" }, [
                    _vm.onTrialPaywall
                      ? _c("span", {
                          staticClass: "b-sprite-paywall-pix-interactives-small"
                        })
                      : _c("span", {
                          staticClass: "b-sprite-paywall-pix-click"
                        })
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Interactive lessons")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Drag objects and manipulate variables to get to aha moments fast."
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "item explanations" }, [
                  _c("span", { staticClass: "icon" }, [
                    _vm.onTrialPaywall
                      ? _c("span", {
                          staticClass: "b-sprite-paywall-pix-chat-small"
                        })
                      : _c("span", {
                          staticClass: "b-sprite-paywall-pix-message"
                        })
                  ]),
                  _vm._v(" "),
                  _c("h4", [_vm._v("In-depth explanations")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n          Master concepts with step-by-step explanations of key ideas and problem solving\n          techniques.\n        "
                    )
                  ])
                ])
              ])
            ],
            1
          )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }